import $ from 'jquery';

$(document).ready(() => {
  setupPopups();
});


function setupPopups() {
  const $popups = $('.js-store-popup-container');

  if (!$popups.length) { return; }

  $popups.each((index, popup) => {
    const $popupToggle = $(popup).find('.js-store-popup-close');
    const $popup = $(popup).find('.js-icons-popup')[0];

    // Bind click on toggles
    $popupToggle.click(e => togglePopup(e, $popup));
  });
}

function togglePopup(e, popup) {
  e.preventDefault();
  $.fancybox({
    content: popup.outerHTML,
    fitToView: true,
    autoSize: true,
  });
}

